import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

import { closeModalPage } from 'actions/modalPage';
import CustomerResults from 'containers/Col1/Search/Customers/CustomerResults';
import { PosPlugin } from 'plugins/plugin';
import { RootState } from 'reducers';

import { getTafReduxState } from '../rdx/reducers';
import { toggleDisplayPreviousEntities } from '../rdx/actions';

const UICustomerResults: PosPlugin['UICustomerResults'] = ({ children }) => {
  const dispatch: ThunkDispatch<RootState, unknown, Action> = useDispatch();
  const {
    customerLastUsedEntities,
    displayPreviousEntities,
    selectedEntityType,
  } = useSelector(getTafReduxState);

  const {
    previousAssociations,
    previousProffesionals,
  } = customerLastUsedEntities;

  const close = useCallback(() => {
    dispatch(toggleDisplayPreviousEntities(false));
    dispatch(closeModalPage());
  }, []);

  const shouldDisplayPrevEntities = (): boolean => {
    if (displayPreviousEntities) {
      if (selectedEntityType === 'association' && previousAssociations.length) {
        return true;
      }
      if (
        selectedEntityType === 'proffesional' &&
        previousProffesionals.length
      ) {
        return true;
      }
    }

    return false;
  };

  return (
    <>
      {shouldDisplayPrevEntities() ? (
        <CustomerResults
          close={close}
          customers={
            selectedEntityType === 'association'
              ? previousAssociations
              : previousProffesionals
          }
          loading={false}
          searchValue=" "
        />
      ) : null}
      {children}
    </>
  );
};

export default UICustomerResults;
